/**
 * Clears all authentication, business, shop, branch, user data, and session-specific
 * cache keys from local and session storage to prevent data leakage or cross-contamination between sessions.
 * Preserves only device-level preferences (language, device ID) and remembered credentials (if enabled).
 */
export const clearAuthSession = (): void => {
  try {
    const isRemember = localStorage.getItem('isRemember') === 'YES';
    const savedUsername = isRemember ? localStorage.getItem('savedUsername') : null;
    const savedPassword = isRemember ? localStorage.getItem('savedPassword') : null;
    const currentLanguage = localStorage.getItem('currentLanguage');
    const currentLangData = localStorage.getItem('currentLangData');
    const preferredLang = localStorage.getItem('preferredLang');
    const deviceId = localStorage.getItem('deviceId');

    // Wipe all localStorage entries
    localStorage.clear();

    // Restore preserved preferences
    if (isRemember && savedUsername && savedPassword) {
      localStorage.setItem('savedUsername', savedUsername);
      localStorage.setItem('savedPassword', savedPassword);
      localStorage.setItem('isRemember', 'YES');
    } else {
      localStorage.setItem('isRemember', 'NO');
    }

    if (currentLanguage) {
      localStorage.setItem('currentLanguage', currentLanguage);
    }
    if (currentLangData) {
      localStorage.setItem('currentLangData', currentLangData);
    }
    if (preferredLang) {
      localStorage.setItem('preferredLang', preferredLang);
    }
    if (deviceId) {
      localStorage.setItem('deviceId', deviceId);
    }
  } catch (e) {
    console.error('Error clearing localStorage auth session:', e);
    // Explicit manual removal fallback
    const explicitKeys = [
      'accessToken',
      'refreshToken',
      'token',
      'isSuperAdmin',
      'userMustLogin',
      'newLogin',
      'shop_id',
      'active_shop_id',
      'business_type',
      'shop_business_type',
      'branch_id',
      'active_branch_id',
      'fuko_selected_branch_id',
      'fuko_cached_user_data',
      'fuko_pos_enable_tables',
      'fuko_support_widget_dismissed',
      'fuko_printer_settings',
      'notifications',
      'currency',
      'currency_code',
      'user',
      'appOpenTime',
    ];
    explicitKeys.forEach((k) => localStorage.removeItem(k));
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('fuko_') || key.startsWith('notifications_'))) {
        localStorage.removeItem(key);
      }
    }
  }

  // Clear all sessionStorage completely
  try {
    sessionStorage.clear();
  } catch (e) {
    console.error('Error clearing sessionStorage:', e);
  }
};

